export default __webpack_public_path__ + "static/media/gear.f9a08e68.svg";